var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeSolid({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "eye-solid",
    d: "M17.892,69.544A10.023,10.023,0,0,0,9,64,10.025,10.025,0,0,0,.109,69.544a1.011,1.011,0,0,0,0,.912A10.023,10.023,0,0,0,9,76a10.025,10.025,0,0,0,8.891-5.544,1.011,1.011,0,0,0,0-.912ZM9,74.5A4.5,4.5,0,1,1,13.5,70,4.5,4.5,0,0,1,9,74.5ZM9,67a2.979,2.979,0,0,0-.791.118,1.5,1.5,0,0,1-2.091,2.091A2.993,2.993,0,1,0,9,67Z",
    transform: "translate(-0.001 -64)",
    fill: "#2186eb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSolid);
export default __webpack_public_path__ + "static/media/eye-solid.00803af862febd49ec0813d3708c9d62.svg";
export { ForwardRef as ReactComponent };